import React from 'react'

import * as S from './styles'

import type { SpinnerProps } from './types'

export const Spinner = ({
  size = 15,
  strokeWidth = 1,
  color,
  bgColor,
  isSingle = true,
  className,
}: SpinnerProps) => (
  <S.Svg
    bgColor={bgColor}
    color={color}
    width={size}
    height={size}
    fill="none"
    viewBox={`0 0 ${size} ${size}`}
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    {!isSingle && (
      <circle
        id="rail"
        strokeWidth={strokeWidth}
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - strokeWidth / 2}
      />
    )}
    <circle
      id="train"
      strokeWidth={strokeWidth}
      cx={size / 2}
      cy={size / 2}
      r={size / 2 - strokeWidth / 2}
    />
  </S.Svg>
)
